import { useEffect, useState } from 'react';
import { fetchSchemaFieldsCached, toFieldNameMap } from '../api/schemaField';

// 字段 key → 显示名 Map (来自 Schema 字段字典, 模块级缓存一次请求).
// 参数中心各处展示字段时统一用它兜底: 行级 label > 字典 fieldName > key.
// 拉取失败静默返回空 Map, 展示自然回退 key, 不阻塞页面.
export function useSchemaFieldNames(): Map<string, string> {
    const [names, setNames] = useState<Map<string, string>>(() => new Map());
    useEffect(() => {
        let alive = true;
        fetchSchemaFieldsCached()
            .then((dict) => {
                if (alive) setNames(toFieldNameMap(dict));
            })
            .catch(() => {
                /* 静默: 回退显示 key */
            });
        return () => {
            alive = false;
        };
    }, []);
    return names;
}

// 字段 key → 枚举来源字典类目 (enums_source) Map. 展示字典受控字段的值时,
// 配合 useDictOptions/dictOptionLabel 把 code 换成 label, 不裸显 code.
export function useSchemaFieldEnumSources(): Map<string, string> {
    const [sources, setSources] = useState<Map<string, string>>(() => new Map());
    useEffect(() => {
        let alive = true;
        fetchSchemaFieldsCached()
            .then((dict) => {
                if (alive) {
                    setSources(
                        new Map(
                            dict
                                .filter((f) => f.enumsSource)
                                .map((f) => [f.fieldKey, f.enumsSource as string]),
                        ),
                    );
                }
            })
            .catch(() => {
                /* 静默: 回退显示 code */
            });
        return () => {
            alive = false;
        };
    }, []);
    return sources;
}
